import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ErrorLog, Success} from '@core/models';
import {environment} from '@env';
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LogsService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public setErrorLog(errorLog: ErrorLog): void {
    this.http.post<Success>(`${environment.apiUrl}auth/error`, errorLog)
      .pipe(
        catchError(async (err) => console.log(err))
      );

  }
}
